/**
 * @module main
 * @description Entry point: loads self-hosted brand fonts, applies golden
 * tokens, then mounts the app.
 *
 * Fonts are self-hosted via @fontsource (no Google Fonts CDN call) so the
 * embed works behind strict CSP rules and has no third-party privacy leak.
 */
import "@fontsource/source-serif-4/400.css";
import "@fontsource/source-serif-4/400-italic.css";
import "@fontsource/source-serif-4/600.css";
import "@fontsource/source-serif-4/700.css";
import "@fontsource/allura/400.css";
import "@fontsource/caveat/400.css";
import "@fontsource/caveat/600.css";
import "./design/tokens.css";
import "./design/app.css";
import "./design/print.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { applyGoldenTokens } from "./design/goldenGeometry";
import { App } from "./app/App";
import { PrintProvider } from "./lib/print/PrintService";

applyGoldenTokens();

const container = document.getElementById("root");
if (!container) throw new Error("#root element missing from index.html");
createRoot(container).render(
    <StrictMode>
        <PrintProvider>
            <App />
        </PrintProvider>
    </StrictMode>
);
